"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Address = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _models = require("../models");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.text.secondary
    };
});
const Address = (param)=>{
    let { forceSingleLine, addressFormat, ...address } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const addressLines = (0, _react.useMemo)(()=>{
        var _addressFormat_lines;
        return ((_addressFormat_lines = addressFormat === null || addressFormat === void 0 ? void 0 : addressFormat.lines) !== null && _addressFormat_lines !== void 0 ? _addressFormat_lines : []).map((param, row, arr)=>{
            let { fields, separators } = param;
            // Add separators
            const items = fields.flatMap((field, index)=>{
                var _Object_entries_find;
                const addressLineItem = (_Object_entries_find = Object.entries(address).find((e)=>e[0].toLocaleLowerCase() === field.toLocaleLowerCase())) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1];
                const separator = separators[index + 1];
                if (!addressLineItem || separator === undefined) {
                    return [];
                }
                return [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        ...getTestIdProps("".concat(_models.TestId.DeliveryBox, "-").concat(field)),
                        children: addressLineItem
                    }, field),
                    separator
                ];
            });
            // Skip line if empty
            if (items.length === 0) {
                return null;
            }
            if (forceSingleLine) {
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key -- index is fine here
                (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        separators[0],
                        items,
                        row < arr.length - 1 && ', '
                    ]
                }, row));
            }
            return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key -- index is fine here
            (0, _jsxRuntime.jsxs)("div", {
                children: [
                    separators[0],
                    items
                ]
            }, row));
        });
    }, [
        addressFormat === null || addressFormat === void 0 ? void 0 : addressFormat.lines,
        forceSingleLine,
        address,
        getTestIdProps
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        children: addressLines
    });
};
exports.Address = Address;
